import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Icon from '@comp/Icon.vue';
import SelectInput from '@comp/forms/inputs/SelectInput.vue';
import FlagIcon from '!!url-loader?!@static/icons/s-flag.svg';
import ArrowIcon from '!!url-loader?!@static/icons/s-arrow-triangle.svg';
import MoneylineIcon from '!!url-loader?!@static/icons/s-moneyline.svg';
import TotalIcon from '!!url-loader?!@static/icons/s-total.svg';
import ParlayIcon from '!!url-loader?!@static/icons/s-parlay.svg';
import SpreadIcon from '!!url-loader?!@static/icons/s-spread.svg';
import InfoTooltip from '@comp/forms/InfoTooltip.vue';
import { profileClient } from '@api/profile';
import { VMenu, VSlideYTransition, VTextField, VDatePicker } from 'vuetify/lib';
import moment from 'moment';
import { statisticNumbersFormatter } from '@utils/format-number';
import Slick from 'vue-slick';
var RowValue = {
  name: 'RowValue',
  filters: {
    statisticNumbersFormatter: statisticNumbersFormatter
  },
  props: ['info'],
  template: "\n    <span class=\"info-value\" v-if=\"info.type == 'winnings'\">{{ info.val | statisticNumbersFormatter({ prefix: '$' }) }}</span>\n    <span class=\"info-value\" v-else-if=\"info.type == 'roi' || info.type == 'pers'\">{{ info.val | statisticNumbersFormatter({ suffix: '%' }) }}</span>\n    <span class=\"info-value\" v-else>{{ info.val }}</span>\n\t"
};
export default {
  name: 'Statistics',
  components: {
    Icon: Icon,
    SelectInput: SelectInput,
    InfoTooltip: InfoTooltip,
    RowValue: RowValue,
    'v-menu': VMenu,
    'v-text-field': VTextField,
    'v-date-picker': VDatePicker,
    'v-slide-y-transition': VSlideYTransition,
    Slick: Slick
  },
  filters: {
    statisticNumbersFormatter: statisticNumbersFormatter
  },
  props: {
    statisticInfo: Array,
    statisticOverall: Object,
    periodLabel: String,
    leagueSelected: String,
    leagueSelectedTitle: String,
    statisticOverallWygerType: Object,
    noLeagueStatictics: Object,
    hasNoLeagueStatictics: Boolean
  },
  data: function data() {
    return {
      FlagIcon: FlagIcon,
      ArrowIcon: ArrowIcon,
      MoneylineIcon: MoneylineIcon,
      TotalIcon: TotalIcon,
      ParlayIcon: ParlayIcon,
      SpreadIcon: SpreadIcon,
      tabActive: 'periodTime',
      slickOptions: {
        arrows: false,
        infinite: false,
        dots: true
      }
    };
  },
  computed: {
    statisticInfoMobile: function statisticInfoMobile() {
      var _this = this;

      if (this.leagueSelected) {
        if (this.leagueSelected === 'parlays_multiple') {
          return _objectSpread(_objectSpread({}, this.noLeagueStatictics), {}, {
            list: [_objectSpread({
              key: 'parlay',
              title: 'Parlay'
            }, this.noLeagueStatictics)]
          });
        }

        return this.statisticInfo.find(function (z) {
          return z.code === _this.leagueSelected;
        });
      } else if (this.statisticOverallWygerType) {
        return this.statisticOverallWygerType;
      }

      return null;
    }
  },
  methods: {
    changeTab: function changeTab(val) {
      this.tabActive = val;
    }
  }
};